module.exports = __webpack_public_path__ + "media/images/OPL 55-9323a8406a59e2230ceee5df5de59dd3.png";